/**
 * @fileoverview gRPC-Web generated client stub for evidencemgmt
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: evidencemgmt/evidencemgmt.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var attachment_attachment_pb = require('../attachment/attachment_pb.js')

var model_control_pb = require('../model/control_pb.js')
const proto = {};
proto.evidencemgmt = require('./evidencemgmt_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.evidencemgmt.EvidenceManagementClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.evidencemgmt.EvidenceManagementPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidencemgmt.GetControlToEvidenceMappingsRequest,
 *   !proto.evidencemgmt.GetControlToEvidenceMappingsResponse>}
 */
const methodDescriptor_EvidenceManagement_GetControlToEvidenceMappings = new grpc.web.MethodDescriptor(
  '/evidencemgmt.EvidenceManagement/GetControlToEvidenceMappings',
  grpc.web.MethodType.UNARY,
  proto.evidencemgmt.GetControlToEvidenceMappingsRequest,
  proto.evidencemgmt.GetControlToEvidenceMappingsResponse,
  /**
   * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidencemgmt.GetControlToEvidenceMappingsResponse.deserializeBinary
);


/**
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidencemgmt.GetControlToEvidenceMappingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidencemgmt.GetControlToEvidenceMappingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidencemgmt.EvidenceManagementClient.prototype.getControlToEvidenceMappings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetControlToEvidenceMappings',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetControlToEvidenceMappings,
      callback);
};


/**
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidencemgmt.GetControlToEvidenceMappingsResponse>}
 *     Promise that resolves to the response
 */
proto.evidencemgmt.EvidenceManagementPromiseClient.prototype.getControlToEvidenceMappings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetControlToEvidenceMappings',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetControlToEvidenceMappings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidencemgmt.GetEvidenceToControlMappingsRequest,
 *   !proto.evidencemgmt.GetEvidenceToControlMappingsResponse>}
 */
const methodDescriptor_EvidenceManagement_GetEvidenceToControlMappings = new grpc.web.MethodDescriptor(
  '/evidencemgmt.EvidenceManagement/GetEvidenceToControlMappings',
  grpc.web.MethodType.UNARY,
  proto.evidencemgmt.GetEvidenceToControlMappingsRequest,
  proto.evidencemgmt.GetEvidenceToControlMappingsResponse,
  /**
   * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidencemgmt.GetEvidenceToControlMappingsResponse.deserializeBinary
);


/**
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidencemgmt.GetEvidenceToControlMappingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidencemgmt.GetEvidenceToControlMappingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidencemgmt.EvidenceManagementClient.prototype.getEvidenceToControlMappings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetEvidenceToControlMappings',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetEvidenceToControlMappings,
      callback);
};


/**
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidencemgmt.GetEvidenceToControlMappingsResponse>}
 *     Promise that resolves to the response
 */
proto.evidencemgmt.EvidenceManagementPromiseClient.prototype.getEvidenceToControlMappings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetEvidenceToControlMappings',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetEvidenceToControlMappings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidencemgmt.GetGapEvidenceMappingsRequest,
 *   !proto.evidencemgmt.GetGapEvidenceMappingsResponse>}
 */
const methodDescriptor_EvidenceManagement_GetGapEvidenceMappings = new grpc.web.MethodDescriptor(
  '/evidencemgmt.EvidenceManagement/GetGapEvidenceMappings',
  grpc.web.MethodType.UNARY,
  proto.evidencemgmt.GetGapEvidenceMappingsRequest,
  proto.evidencemgmt.GetGapEvidenceMappingsResponse,
  /**
   * @param {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidencemgmt.GetGapEvidenceMappingsResponse.deserializeBinary
);


/**
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidencemgmt.GetGapEvidenceMappingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidencemgmt.GetGapEvidenceMappingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidencemgmt.EvidenceManagementClient.prototype.getGapEvidenceMappings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetGapEvidenceMappings',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetGapEvidenceMappings,
      callback);
};


/**
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidencemgmt.GetGapEvidenceMappingsResponse>}
 *     Promise that resolves to the response
 */
proto.evidencemgmt.EvidenceManagementPromiseClient.prototype.getGapEvidenceMappings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetGapEvidenceMappings',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetGapEvidenceMappings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest,
 *   !proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse>}
 */
const methodDescriptor_EvidenceManagement_GetControlToEvidenceMappingInfo = new grpc.web.MethodDescriptor(
  '/evidencemgmt.EvidenceManagement/GetControlToEvidenceMappingInfo',
  grpc.web.MethodType.UNARY,
  proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest,
  proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse,
  /**
   * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.deserializeBinary
);


/**
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidencemgmt.EvidenceManagementClient.prototype.getControlToEvidenceMappingInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetControlToEvidenceMappingInfo',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetControlToEvidenceMappingInfo,
      callback);
};


/**
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse>}
 *     Promise that resolves to the response
 */
proto.evidencemgmt.EvidenceManagementPromiseClient.prototype.getControlToEvidenceMappingInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetControlToEvidenceMappingInfo',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetControlToEvidenceMappingInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest,
 *   !proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse>}
 */
const methodDescriptor_EvidenceManagement_GetEvidenceToControlMappingInfo = new grpc.web.MethodDescriptor(
  '/evidencemgmt.EvidenceManagement/GetEvidenceToControlMappingInfo',
  grpc.web.MethodType.UNARY,
  proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest,
  proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse,
  /**
   * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.deserializeBinary
);


/**
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidencemgmt.EvidenceManagementClient.prototype.getEvidenceToControlMappingInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetEvidenceToControlMappingInfo',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetEvidenceToControlMappingInfo,
      callback);
};


/**
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse>}
 *     Promise that resolves to the response
 */
proto.evidencemgmt.EvidenceManagementPromiseClient.prototype.getEvidenceToControlMappingInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidencemgmt.EvidenceManagement/GetEvidenceToControlMappingInfo',
      request,
      metadata || {},
      methodDescriptor_EvidenceManagement_GetEvidenceToControlMappingInfo);
};


module.exports = proto.evidencemgmt;

